import React from 'react';
import { Box, Button, Container, Typography } from '@mui/material';
import { Link } from 'react-router-dom';
import PageHelmet from '../SEO/PageHelmet';
import YovoTripHeader from '../Header/YovoTripHeader';
import GlobalFooter from './GlobalFooter/GlobalFooter';

const MAROON = '#8B1A35';

export default function NotFoundPage() {
  return (
    <>
      <PageHelmet
        title="Page Not Found"
        description="The page you are looking for could not be found on YovoTrip."
        noIndex
      />
      <Box sx={{ minHeight: '100vh', display: 'flex', flexDirection: 'column', bgcolor: '#F9FAFB' }}>
        <YovoTripHeader />
        <Container
          maxWidth="sm"
          sx={{
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            py: 8,
            textAlign: 'center',
          }}
        >
          <Typography variant="h1" sx={{ fontSize: { xs: '2rem', md: '2.5rem' }, fontWeight: 700, color: '#111827', mb: 2 }}>
            Page not found
          </Typography>
          <Typography sx={{ color: '#6B7280', mb: 4, maxWidth: 420 }}>
            We could not find the page you requested. Try searching for flights from the homepage instead.
          </Typography>
          <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap', justifyContent: 'center' }}>
            <Button
              component={Link}
              to="/flights"
              variant="contained"
              sx={{ bgcolor: MAROON, '&:hover': { bgcolor: '#6D1429' }, textTransform: 'none', fontWeight: 600 }}
            >
              Search flights
            </Button>
            <Button component={Link} to="/" variant="outlined" sx={{ textTransform: 'none', fontWeight: 600 }}>
              Go to homepage
            </Button>
          </Box>
        </Container>
        <GlobalFooter variant="compact" />
      </Box>
    </>
  );
}
